import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const RequiredTypography = styled(Typography)({
    fontSize: '1rem',
    color: '#d0021b',
})

const RequiredLabel = () => {
    const { t } = useTranslation()
    return (
        <RequiredTypography variant="label">{`${t(
            'Common_Required',
        )} *`}</RequiredTypography>
    )
}

export default RequiredLabel
